module.exports = fox._r("fonts/iconfont.ttf?ldnvmv", __webpack_public_path__ + "fonts/3PGntxB.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/iconfont.ttf?ldnvmv
// module id = 948
// module chunks = 4